import { render, staticRenderFns } from "./TalkList.vue?vue&type=template&id=16ce8994&"
import script from "./TalkList.vue?vue&type=script&lang=ts&"
export * from "./TalkList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports